const calcRu = {
  heroTitle: "Калькулятор <1>матрицы судьбы</1>",
  heroAboutCalc:
    "Продвинутый калькулятор для быстрого и профессионального расчета.",
  heroAuthoring:
    "Калькулятор на 100% соответствует классическому вычислению «Матрицы Судьбы» Наталии Ладини",
  changeYourFateTitle: "Какой уже раз пытаешься расшифровать свою матрицу?",
  changeYourFateAssistanseText:
    "А ведь это не главное. Гораздо важнее знать, как с её помощью реально менять свою жизнь.  И вот с этим я помогу.",
  changeYourFateConsultationBtn: "выбрать формат консультации",
  changeYourFateCalcAuthor1: "Обучиться всем профессиональным расчётам можно у",
  changeYourFateCalcAuthor2: "Наталии Ладини",
  changeYourFateCalcAuthor3: "и",
  changeYourFateCalcAuthor4: "Сергея Скляренко",
  donationLikeTheProject:
    "Если тебе нравится калькулятор — помоги ему оставаться бесплатным.",
  donationSaveService:
    "Оформи небольшую подписку или оставь разовый донат. Твоя поддержка помогает оплачивать работу сервиса, развивать его и сохранять бесплатный доступ для всех.",
  contactsTitle: "Контакты",
  getPDFTemplateTitle: "Получи PDF-шаблон для расчета Матрицы Судьбы!",
  getPDFTemplateHowTo1: "Подписывайся на",
  getPDFTemplateHowTo2:
    "и пиши в личные сообщения кодовую фразу “Хочу Шаблоны”",
  footerPoliticText1: "Политика конфиденциальности",
  footerPoliticText2: "Разработано командой dari.karma",
  fullOverlapCheckbox: "Техника полного наложения матриц",
  method2023: "Техника наложения 8 карм",
  personalMatrixCalc: "Рассчитать",
  personalMatrixBoxTitle: "Ввод данных",
  personalMatrixNamePlaceholder: "Имя",
  personalMatrixDatePlaceholder: "Дата рождения",
  personalMatrixDateRequired: "Введите дату",
  personalMatrixDatePattern: "Введите дату в формате dd.mm.yyyy",
  aboutCustomerAge: "Возраст",
  aboutCustomerPeriod: "Период",
  assignmentTabledfirstName1: "Небо",
  assignmentTabledfirstName2: "Отец",
  assignmentTabledsecondName1: "Земля",
  assignmentTabledsecondName2: "Мать",
  assignmentTabledthrirdName1: "Личное",
  assignmentTabledthrirdName2: "Социальное",
  assignmentTabledname1: "Духовное",
  assignmentTabledname2: "Планетарное",
  assignmentTabledkey: "Ключ силы",
  assignmentTabledthrirdNameDesk1: "Личное предназначение",
  assignmentTabledthrirdNameDesk2: "Социальное предназначение",
  karmaIssuesEnergy: "Энергия",
  healthAuthor: "авторская",
  healthAuthorPasswordModalData: "Введите ключ доступа",
  incorrectPassword: "! Неверный пароль",
  healthAuthorWarning1:
    '<0>ВНИМАНИЕ!</0> Система "INTEGRITY" является разработкой команды "Dari.Karma" и представлена на сайте для тестирования.',
  healthAuthorWarning2:
    "Данный расчёт карты здоровья <1>не соответствует </1> алгоритму расчёта Н. Ладини",
  healthCardTypePersonal: "Классическая",
  healthCardTipPurpose: "Функция",
  healthCardTipInternalCondition: "Внутреннее состояние",
  healthCardTipDisturbance: "Нарушения",
  healthCardTipVerb: "Глагол",
  check: "Смотреть",
  healthAuthorLesson: 'УРОК О СИСТЕМЕ "INTEGRITY"',
  result: "Итог",
  periodMatrixHeader: "Энергии покровители по годам",
  tableMatrix: "Матрица",
  classic: "Классическая",
  compatibility: "Совместимость",
  compatibilityMatrix: "МАТРИЦА СОВМЕСТИМОСТИ",
  add: "Добавить",
  annualMatrix: "Матрица года",
  year: "Год",
  yearEnterError: "Введите год",
  yearPatternError: "Введите 4-значный год от 2000 до 2100",
  yearPeriods: "Периоды года",
  deepCalcProg: "ПРОГРАММЫ",
  deepGenericBtn1: "РОДОВЫЕ",
  deepGenericBtn2: "ЦелостнЫЕ",
  motherMatrixTitle: "МАТРИЦА МАТЕРИ",
  childMatrixTitle: "МАТРИЦА РЕБЕНКА",
  instructionTitle:
    "Используй возможности калькулятора от <1>Dari.Karma</1> на все 100%",
  instructionCircleBtn1: "Видеоинструкция к калькулятору",
  instructionCircleBtn2: 'Бесплатные вебинары об "INTEGRITY"',
  instructionBtn1: "Видеоинструкция к калькулятору",
  instructionBtn2: 'Бесплатные вебинары об "INTEGRITY"',
  instructionModalTitle1: "Секретные фишки калькулятора",
  instructionModalTitle2: 'Вебинары по системе "INTEGRITY"',
  instructionModalBtn1: "купить инструкцию",
  instructionModalBtn2: "Смотреть бесплатно",
  deepLightGateBtn: "Исцеление",
};
export default calcRu;
